__webpack_require__.p = "/ci-cd-ynov-2/";